interface ErrorProps {
  message: string;
  onRetry?: () => void;
}

export function Error({ message, onRetry }: ErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <div className="text-4xl mb-4">😕</div>
      <h2 className="text-lg font-semibold mb-2 text-tg-text">
        Algo salió mal
      </h2>
      <p className="text-tg-hint mb-4">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-6 py-2 bg-tg-button text-tg-button-text rounded-lg font-medium"
        >
          Reintentar
        </button>
      )}
    </div>
  );
}

